import { useTranslation } from 'react-i18next'
import { Box, Text, Toggle } from '@machobear/design-system'
import { useListingData } from '../../context/listing-data'
import { useListingActions } from '../../context/listing-actions'

export const ListingHidingControl = () => {
  const { t } = useTranslation()

  const { listingHidden = false } = useListingData()
  const { hideListing, unhideListing } = useListingActions()

  return (
    <>
      <Box display="flex" flexDirection="column" gap="xsmall">
        <Text size="small" weight={listingHidden ? 'strong' : 'regular'}>
          {t('Hide listing')}
        </Text>
        <Text size="xsmall" tone="tertiary">
          {t('Listing will be hidden from public')}
        </Text>
      </Box>

      <Toggle
        id="hide_listing"
        align="right"
        on={listingHidden}
        label=""
        onChange={listingHidden ? unhideListing : hideListing}
      />
    </>
  )
}
